import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import SwipeableViews from 'react-swipeable-views';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import PriceGrid from './PriceGrid.js'


import './App.css';


function TabContainer({ children, dir }) {
  return (
    <Typography component="div" dir={dir} style={{ padding: 8 * 3 }}>
      {children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
  dir: PropTypes.string.isRequired,
};

const styles = theme => ({
  root: {
    flexGrow: 1,
    // backgroundColor: theme.palette.background.paper,
    backgroundColor: 'white'
  },
  tabsRoot: {
    borderBottom: '1px solid #e8e8e8',
    backgroundColor: 'white'
  },
  tabsIndicator: {
    backgroundColor: '#203b60',
  },
  tabRoot: {
    textTransform: 'initial',
    minWidth: 72,
    backgroundColor: 'white',
    fontWeight: theme.typography.fontWeightRegular,
    // marginRight: theme.spacing.unit * 4,
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:hover': {
      color: '#203b60',
      opacity: 1,
    },
    '&$tabSelected': {
      color: '#203b60',
      fontWeight: 'bold',
      // fontWeight: theme.typography.fontWeightMedium,
    },

  },
  tabSelected: {},
  typography: {
    padding: theme.spacing.unit * 3,
  },
  paperRoot: {
    // ...theme.mixins.gutters(),
    // paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
  },
  paperRootMargin: {
    paddingBottom: theme.spacing.unit * 2,
    marginTop: '5px',
    textAlign:'center',
    display:'flex',
    flexDirection:'column'

  }
});


class PriceCalc extends Component {

  constructor(props) {
    super(props);
    this.state = {
      period: 'year',
      tab: 0
    }
    this.handleTabChange = this.handleTabChange.bind(this);

  }

  handleTabChange = (event, value) => {
    console.log("tab change")
    console.log(value)
    var period;
    if (value === 1) {
      period = 'month'
    }
    if (value === 0) {
      period = 'year'
    }
    this.props.setPeriod(period)
    this.setState({ tab: value, period: period });
  };

  handleChangeIndex = index => {
    console.log("INDEX")
    console.log(index)
    this.setState({ tab: index });
  };




  render() {

    const { classes, theme } = this.props;


    return (
      <div className="sticky-top-custom">
        <Paper className={classes.paperRoot} elevation={1}>
          {/* <div className={classes.root}> */}
          <AppBar position="static" color="default">
            <Tabs
              value={this.state.tab}
              onChange={this.handleTabChange}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
              classes={{ root: classes.tabsRoot, indicator: classes.tabsIndicator }}
            >
              <Tab classes={{ root: classes.tabRoot, selected: classes.tabSelected }} label="Anual" />
              <Tab classes={{ root: classes.tabRoot, selected: classes.tabSelected }} label="Mensual" />
            </Tabs>
          </AppBar>
          <SwipeableViews
            axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
            index={this.state.tab}
            onChangeIndex={this.handleChangeIndex}
          >
            <TabContainer dir={theme.direction}><PriceGrid users={this.props.users} prices={this.props.prices} period={this.props.period} apps={this.props.apps} support={this.props.support} buy={this.props.buy} saveSelection={this.props.saveSelection} /></TabContainer>
            <TabContainer dir={theme.direction}><PriceGrid users={this.props.users} prices={this.props.prices} period={this.props.period} apps={this.props.apps} support={this.props.support} buy={this.props.buy} saveSelection={this.props.saveSelection} /></TabContainer>
          </SwipeableViews>
          {/* </div> */}
        </Paper>

        {this.props.pack &&
          <Paper className={classes.paperRootMargin} elevation={1}>
            <div className="card-title">{this.props.pack.name}</div>
            
            <div style={{paddingTop:'0px', fontWeight:800}} className="pricing-title">${this.props.pack.new} USD</div>

          </Paper>
        }

      </div>
    );
  }
}

PriceCalc.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(PriceCalc);

